import React, {
    useState,
    useEffect
} from 'react';

import {
    SearchOutlined,
} from '@ant-design/icons';

import {
    message,
    Form,
    Input,
    Popconfirm,
    DatePicker,
    InputNumber,
    Divider,
    Button,
    Table
} from "antd"

import {
    db,
    storr
} from '../firebase/firebase'

const { RangePicker } = DatePicker;

const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
}) => {
    const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
    return (
        <td {...restProps}>
            {editing ? (
                <Form.Item
                    name={dataIndex}
                    style={{
                        margin: 0,
                    }}
                    rules={[
                        {
                            required: true,
                            message: `Please Input ${title}!`,
                        },
                    ]}
                >
                    {inputNode}
                </Form.Item>
            ) : (
                children
            )}
        </td>
    );
};

const ScreenSaver = () => {
    useEffect(() => {
        pullFromDB()
    }, []);

    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [editingKey, setEditingKey] = useState('');
    const [pendingData, setPendingData] = useState({ disabled: true, inputDisabled: false });
    const [disabled, setDisabled] = useState(true);
    const [range, setRange] = useState([]);


    const isEditing = (record) => record.key === editingKey;

    const edit = (record) => {
        console.log('ff')
        form.setFieldsValue({
            filename: '',
            startdate: '',
            ...record,
        });
        setEditingKey(record.key);
    };

    const cancel = () => {
        setEditingKey('');
    };

    const save = async (key) => {
        try {
            const row = await form.validateFields();
            const newData = [...data];
            const index = newData.findIndex((item) => key === item.key);

            if (index > -1) {
                const item = newData[index];
                newData.splice(index, 1, { ...item, ...row });

                try {

                    await db
                        .collection("screensavers")
                        .doc(data[index].id).update({
                            //to do in the future: maybe convert the user editted date into isostring format, so can store together
                            // date: this.state.da,
                            screensaver_name: newData[index].screensaver_name
                        })
                    message.success("Event " + newData[index].filename + " successfully updated!");
                    setData(newData)
                    setEditingKey('');

                } catch (error) {
                    message.error(error.message);

                }

            } else {
                newData.push(row);
                setData(newData);
                setEditingKey('');
            }
        } catch (errInfo) {
            console.log('Validate Failed:', errInfo);
        }
    }

    const toLocalTime = (ts) => {
        var dt = new Date(ts).toLocaleString();
        return dt
    }

    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({
            setSelectedKeys, selectedKeys, confirm, clearFilters,
        }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => { this.searchInput = node; }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => handleSearch(selectedKeys, confirm)}
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Search
            </Button>
                <Button
                    onClick={() => handleReset(clearFilters)}
                    size="small"
                    style={{ width: 90 }}
                >
                    Reset
            </Button>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined />,
        onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
                setTimeout(() => this.searchInput.select());
            }
        },
        render: (text) => (
            text
        ),
    })
    const pullFromDB = () => {

        // We listen for live changes to our data collection in Firebase
        db.collection("screensavers").onSnapshot(snapshot => {
            //data is locally available array, pulled from firestore.
            let data = [];
            snapshot.forEach(doc => {
                const todo = doc.data();
                todo.id = doc.id;
                data.push(todo);
            });

            // Sort our data based on time added
            data.sort(function (a, b) {
                return (
                    new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
                );
            });

            //assign primary key
            for (var i = 0; i < data.length; i++) {
                data[i].key = i;
            }
            // console.log(data);

            // Anytime the state of our database changes, we update state
            setData(data)

        })
        // var ref = db.collection("screensavers").doc(this.props.match.params.id)
        // ref.get().then((doc) => {

        //     this.setState({
        //         master: doc.data(),
        //     });
        //     this.handleChange();
        // })


    }
    const columns = [
        {
            title: 'Screensaver name',
            dataIndex: 'screensaver_name',
            editable: true,
            ...getColumnSearchProps('screensaver_name'),
            sorter: (a, b) => { return a.screensaver_name.localeCompare(b.screensaver_name) },
        },
        {
            title: 'Start Date',
            dataIndex: 'startdate',
            inputType: 'number',
            sorter: (a, b) => parseInt(a.startdate, 10) - parseInt(b.startdate, 10),
            render: (text, record) => {
                return (
                    <div>
                        {toLocalTime(text)}
                    </div>
                );
            },
        },
        {
            title: 'End Date',
            dataIndex: 'enddate',
            sorter: (a, b) => parseInt(a.enddate, 10) - parseInt(b.enddate, 10),
            render: (text, record) => {
                return (
                    <div>
                        {toLocalTime(text)}
                    </div>
                );
            },
        },
        {
            title: 'Media Link',
            dataIndex: 'link',
            editable: false,
            render: (text, record) => {
                return (
                    <div>
                        <a href={record.link} target="_blank">
                            <img src={record.link} alt="" height='150' />
                        </a>
                    </div>
                );
            },
        },
        {
            title: '',
            width: '10%',
            dataIndex: 'operation',
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        <Button
                            href=""
                            onClick={e => {
                                e.preventDefault()
                                save(record.key)
                            }}
                            style={{
                                marginRight: 8,
                            }}
                        >
                            Save
            </Button>
                        <Button type="primary" onClick={() => cancel(record.key)}>Cancel</Button>
                    </span>
                ) : (
                    <div>
                        <Button disabled={editingKey !== ''} onClick={() => edit(record)}>
                            Edit
          </Button>
                        <Divider type="vertical" />

                        <Popconfirm
                            title="Confirm Delete?"
                            onConfirm={evt => deleteProject(record.key)}
                        >
                            <Button
                                type="danger"
                            >
                                Delete
                  </Button>
                        </Popconfirm>

                    </div>
                );
            },
        },
    ];

    const handleSearch = (selectedKeys, confirm) => {
        confirm();
    }

    const handleReset = (clearFilters) => {
        clearFilters();
    }

    const handleChange = (e) => {
        setRange(e)
    }



    const addScreensaver = () => {

        if (pendingData.file != null) {
            var tempC = pendingData
            tempC.inputDisabled = true
            tempC.disabled = true
            setPendingData(tempC)

            uploadThenAddToDatabase(pendingData)
        } else {
            message.error("Something wrong happened, no file was in it")
        }
    }

    const uploadThenAddToDatabase = async (ahh) => {

        message.loading('Uploading...')
        console.log(JSON.stringify(ahh))
        var docy = db.collection("screensavers").doc()

        var refy = storr.ref(docy.id + ahh.file.name.substring(ahh.file.name.lastIndexOf('.'), ahh.file.name.length));

        await refy.put(ahh.file)
        let url = await refy.getDownloadURL()

        var startdate = Date.now()
        var enddate = Date.now()

        if (range.length > 1) {

            startdate = range[0].valueOf()
            enddate = range[1].valueOf()
        }

        await docy.set({
            startdate: startdate,
            enddate: enddate,
            filename: ahh.file.name,
            screensaver_name: docy.id,
            link: url
        })

        if (document.getElementById("uploadCaptureInputFile"))
            document.getElementById("uploadCaptureInputFile").value = ""

        ahh.file = null
        ahh.inputDisabled = false
        ahh.disabled = true
        setPendingData(ahh)
        setDisabled(true)
        message.destroy()
        message.success("Uploaded successfully")
    }

    const clearInputFile = () => {
        var tempB = pendingData
        document.getElementById("uploadCaptureInputFile").value = ""
        tempB.file = null
        tempB.disabled = true
        setPendingData(tempB)
        setDisabled(tempB.disabled)
    }

    const deleteProject = async (id) => {
        var fn = data[id].filename
        var idea = data[id].id

        var ext = fn.substring(fn.lastIndexOf('.'), fn.length)

        await db
            .collection("screensavers")
            .doc(idea)
            .delete().then(function () {
                message.success("Row deleted successfully")
                var ref = storr.ref(idea + ext);
                // Get the download URL
                ref.delete().then(function () {
                    message.success("File " + fn + " deleted successfully")
                }).catch(function (error) {
                    message.error(error.message)
                });
            }).catch(function (error) {
                message.error(error.message)
            });
    }

    const handlePreuploadFile = (event) => {

        var abb = pendingData;

        var whitelistedFormats = ["image/png", "image/jpeg"];
        var acceptedFileFormat = whitelistedFormats.includes(event.target.files[0].type)

        if (event.target.files[0]) {
            if (acceptedFileFormat) {
                console.log("accepted file format")
                if (event.target.files[0].size < 100000000) {
                    abb.disabled = false
                    message.info("You inputed " + event.target.files[0].name)
                    abb.file = event.target.files[0]
                } else {
                    message.error("File is too big");
                    event.target.value = ""
                    abb.file = null
                    abb.disabled = true
                }
            } else {
                message.error("Not the accepted file type");
                event.target.value = ""
                abb.file = null
                abb.disabled = true
            }
        } else {
            message.error("No file in it");
            event.target.value = ""
            abb.file = null
            abb.disabled = true
        }
        setPendingData(abb)
        setDisabled(abb.disabled)
    }

    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }

        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: col.dataIndex === 'age' ? 'number' : 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });
    return (
        <div>
            <h1>Screensavers</h1>

            <br></br>
            <div className="gutter-box">
                <RangePicker
                    onChange={handleChange}
                    showTime
                />
            </div>
            <div className="gutter-box">
                <Button
                    type="danger"
                    onClick={clearInputFile}
                    disabled={pendingData.inputDisabled}
                    ghost
                >
                    Clear file
        </Button>
            </div>
            <input type="file"
                id="uploadCaptureInputFile"
                accept="image/*"
                onChange={handlePreuploadFile}
                disabled={pendingData.inputDisabled}
            />
            <div className="gutter-box">
                <Button
                    className="inputt App-add-todo-button"
                    size="large"
                    type="primary"
                    onClick={addScreensaver}
                    disabled={disabled}
                >
                    Add a Media file
  </Button>
            </div>
            <Form form={form} component={false}>
                <Table
                    components={{
                        body: {
                            cell: EditableCell,
                        },
                    }}
                    bordered
                    dataSource={data}
                    columns={mergedColumns}
                    rowClassName="editable-row"
                    pagination={{
                        onChange: cancel,
                    }}
                />
            </Form>
        </div>
    );
};

export default ScreenSaver;



//     componentWillUnmount() {

//         document.getElementById("uploadCaptureInputFile").value = ""
//     }


//     handleChange(value, dateString) {
//         console.log('Selected Time: ', value);
//         console.log('Formatted Selected Time: ', dateString);
//     }



// WEBPACK FOOTER //
// ./src/views/screensaver.js